<template>
  <div>
    <b-card class="mb-0" no-body>
      <validation-observer ref="modalEdit">
        <div class="p-1">
          <b-row>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Kho">
                <b-form-group label="Kho">
                  <Select2 v-model="serverParams.columnFilters.STORE" :options="storeList"
                           :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Nguồn đơn">
                <b-form-group label="Nguồn đơn">
                  <Select2 v-model="serverParams.columnFilters.CREATEFROM" :options="orderSource"
                           :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Trạng thái">
                <b-form-group label="Trạng thái">
                  <Select2 v-model="serverParams.columnFilters.STATUS" :options="statusList"
                           :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Cổng thanh toán">
                <b-form-group label="Cổng thanh toán">
                  <Select2 v-model="serverParams.columnFilters.PAYMENTCHANNEL" :options="paymentGates"
                           :state="errors.length > 0 ? false:null"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Từ ngày">
                <b-form-group label="Từ ngày">
                  <b-input-group label="Từ ngày">
                    <b-form-datepicker v-model="serverParams.columnFilters.FROM"
                                       :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                                       :state="errors.length > 0 ? false:null"
                                       close-button locale="vi-VN" reset-button
                                       today-button/>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" md="3">
              <validation-provider #default="{ errors }" :rules="''" name="Đến ngày">
                <b-form-group label="Đến ngày">
                  <b-input-group label="Đến ngày">
                    <b-form-datepicker v-model="serverParams.columnFilters.TO"
                                       :date-format-options="{  year: 'numeric', month: 'numeric', day: 'numeric',}"
                                       :state="errors.length > 0 ? false:null"
                                       close-button locale="vi-VN" reset-button
                                       today-button/>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </div>

      </validation-observer>
    </b-card>
    <div class="p-1 text-center">
      <b-button variant="primary" @click="$router.go($router.currentRoute)"> Xoá trắng</b-button>
      <b-button class="ml-1" variant="primary" @click="printDetail">Xem báo cáo</b-button>
      <b-button class="ml-1" variant="secondary" @click="exportExcel">Xuất file Excel</b-button>
    </div>
    <b-row>
      <b-col cols="12" md="12">
        <vue-pdf-app v-if="isHaveData==0" :fileName="currentItem.fileName" :pdf="pdf" class="rounded"
                     pageScale="100" style="height:calc(100vh - 400px)"></vue-pdf-app>
        <vue-pdf-app v-else-if="isHaveData==1" :fileName="currentItem.fileName" :pdf="pdf" class="rounded"
                     pageScale="100" style="height:calc(100vh - 400px)"></vue-pdf-app>
        <div v-else class="rounded" pageScale="100" style="height:85vh"> Không có dữ liệu</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import moment from 'moment';
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

extend('laisuat', value => {
  if ((value + "").indexOf('.') < 0) {
    return true;
  }
  return (value + "").split('.')[1].length <= 2
});

export default {
  components: {
    VuePdfApp,
    BInputGroup,
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadStores()
    useJwt.get('order_source').then(res => {
      this.orderSource = res.data.result
    })
  },

  watch: {
    $route(to, from) {
      this.pdf = null;
    },
  },
  data() {
    return {
      isLoading: false,
      editMode: false,
      currentItem: {attribute: {}},
      isHaveData: 0,
      pdf: null,
      storeList: [{
        id: -1,
        text: "Tất cả"
      }],
      statusList: [
        {id: -1, text: "Tất cả các trạng thái"},
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/Chờ xác nhận"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"}
      ],
      paymentGates: [
        {id: -1, text: "Tất cả"},
        {id: 'VNPAY', text: "VNPAY"},
        {id: 'MOMO', text: "MOMO"},
        {id: 'ZALOPAY', text: "ZALOPAY"}
      ],
      orderSource: [],
      serverParams: {
        columnFilters: {STATUS: -1, STORE: -1, PAYMENTCHANNEL: -1},
        sort: [],
        page: 1,
        pageSize: 50
      },
      required
    }
  },
  methods: {
    printDetail(row) {
      this.loading(true)
      useJwt.post('jasper', {
        name: 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".pdf",
        type: 'pdf',
        src: 'web',
        report: this.$route.meta.report,
        parameter: {
          ...this.serverParams.columnFilters,
          STORE: this.serverParams.columnFilters.STORE == -1 ? null : this.serverParams.columnFilters.STORE,
          PAYMENTCHANNEL: this.serverParams.columnFilters.PAYMENTCHANNEL == -1 ? null : this.serverParams.columnFilters.PAYMENTCHANNEL

        }
      }, {responseType: 'arraybuffer'}).then(response => {
        this.pdf = response.data;
        this.loading(false);
      }).catch((error) => {
        this.loading(false);
      });
    },
    exportExcel(row) {
      this.loading(true)
      useJwt.post('jasper', {
        name: 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".xlsx",
        type: 'xlsx',
        src: 'web',
        report: this.$route.meta.report,
        parameter: {
          ...this.serverParams.columnFilters,
          STORE: this.serverParams.columnFilters.STORE == -1 ? null : this.serverParams.columnFilters.STORE,
          PAYMENTCHANNEL: this.serverParams.columnFilters.PAYMENTCHANNEL == -1 ? null : this.serverParams.columnFilters.PAYMENTCHANNEL
        }
      }, {responseType: 'arraybuffer'}).then(response => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(new Blob(
            [response.data],
            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        ))
        a.download = 'B2C_SUMMARY_' + moment().format('YYYY-MM-DD') + ".xlsx"
        a.click()
        this.loading(false);
      }).catch((error) => {
        this.loading(false);
      });
    },
    loadStores() {
      const data = {
        "columnFilters": {},
        "page": 0,
        "pageSize": 0,
        "sort": []
      }

      useJwt.post('getMasterData/B2C_Store', data).then(response => {
        if (+response.data.code == 200) {
          this.storeList = [{
            id: -1,
            text: "Tất cả"
          },
            ...response.data.result.map(item => ({id: item.Id, text: item.Name}))];
        } else {
          this.storeList = [{
            id: -1,
            text: "Tất cả"
          }]
        }
      }).catch(error => {
        this.storeList = [{
          id: -1,
          text: "Tất cả"
        }]
      })
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
